import { useContext } from 'react'
import {
  checkIfCustomerHasSavedCardsRequest,
  deleteCustomerCardRequest,
  getCustomerCardsDataRequest
} from '../../../helpers/pinflagRequest'
import { DataContext } from '../../../context/DataContext'

export const usePaymentActions = ({
  paymentState,
  setPaymentState,
  paymentOrderData,
  paymentSetters,
  userToken
}) => {
  const { companyInfo } = useContext(DataContext)
  const { ownPayments } = companyInfo
  const {
    setIsUsingSavedCards
  } = paymentSetters

  const defaultHandlers = {
    successHandler: () => {},
    errorHandler: () => {},
    finallyHandler: () => {}
  }

  const getCustomerCardsData = async ({
    successHandler,
    errorHandler,
    finallyHandler
  } = defaultHandlers) => {
    try {
      const response = await getCustomerCardsDataRequest({
        customer: paymentOrderData.customer,
        paymentMethodsConfiguration: ownPayments,
        userToken: userToken.current
      })
      setPaymentState((prevState) => ({
        ...prevState,
        cardsData: response,
        isLoadingCardsData: false
      }))
      successHandler(response)
    } catch (error) {
      console.error('❗Error al obtener las tarjetas almacenadas:', error)
      errorHandler(error)
    } finally {
      finallyHandler()
    }
  }

  const filterDeletedCard = (cardId) => {
    setPaymentState((prevState) => ({
      ...prevState,
      cardsData: paymentState.cardsData.filter(
        (card) => card.cardId !== cardId
      )
    }))
  }

  const postDeleteCustomerCard = async () => {
    return getCustomerCardsData({
      ...defaultHandlers,
      errorHandler: filterDeletedCard
    })
  }

  const deleteCustomerCardError = (error) => {
    console.error('❗Error al eliminar la tarjeta:', error)
    // Show error message
    setPaymentState((prevState) => ({
      ...prevState,
      paymentError:
        'Ocurrió un error al eliminar la tarjeta, intenta nuevamente'
    }))
  }

  const deleteCustomerCard = (card) => {
    setPaymentState((prevState) => ({
      ...prevState,
      isLoadingCardsData: true
    }))
    deleteCustomerCardRequest({
      cardId: card.id,
      customer: paymentOrderData.customer,
      userToken: userToken.current
    }).then(() => {
      try {
        return postDeleteCustomerCard()
      } catch (error) {
        deleteCustomerCardError(error)
      } finally {
        setPaymentState((prevState) => ({
          ...prevState,
          isLoadingCardsData: false
        }))
      }
    })
  }

  const checkIfCustomerHasSavedCards = () => {
    return checkIfCustomerHasSavedCardsRequest({
      customer: paymentOrderData.customer,
      paymentMethodsConfiguration: ownPayments
    })
      .then((response) => {
        setPaymentState((prevState) => ({
          ...prevState,
          hasSavedCards: response.hasSavedCardData,
          showSavedCardModal: response.hasSavedCardData
        }))
      })
      .catch((error) => {
        console.error(
          '❗Error al verificar si el cliente tiene tarjetas:',
          error
        )
      })
      .finally(() => {
        setPaymentState((prevState) => ({
          ...prevState,
          isLoadingCheckIfCustomerHasSavedCards: false
        }))
      })
  }

  const handleUseSavedCards = () => {
    // If hasn't fetched the cards data yet, show the modal, otherwise, show the cards
    if (paymentState.cardsData.length === 0) {
      setPaymentState((prevState) => ({
        ...prevState,
        showSavedCardModal: true
      }))
    } else {
      setIsUsingSavedCards(true)
    }
  }

  const hideOtherPaymentOptions = () => {
    // Reset the selected native payment method
    setPaymentState((prevState) => ({
      ...prevState,
      nativePaymentEnabled: false,
      selectedNativePaymentMethod: ''
    }))
  }

  return {
    paymentActions: {
      checkIfCustomerHasSavedCards,
      deleteCustomerCard,
      getCustomerCardsData,
      hideOtherPaymentOptions,
      handleUseSavedCards
    }
  }
}
